import { render, staticRenderFns } from "./BooleanPillRenderer.vue?vue&type=template&id=74bf8a90&scoped=true"
import script from "./BooleanPillRenderer.vue?vue&type=script&lang=js"
export * from "./BooleanPillRenderer.vue?vue&type=script&lang=js"
import style0 from "./BooleanPillRenderer.vue?vue&type=style&index=0&id=74bf8a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bf8a90",
  null
  
)

export default component.exports